export default {
    contractEditHeader: {
        backToBinEditor: 'Back to bin editor',
        loadError: "Couldn't load contract",
    },
}
